import Box from "@mui/material/Box"
import Tab from "@mui/material/Tab"
import Tabs from "@mui/material/Tabs"
import { useEffect, useState } from "react"
import { useMediaQuery } from "react-responsive"
import requests from "src/services/requests"
import Plan from "./plan"

export default function PlansList() {
  const isMobile = useMediaQuery({ maxWidth: 767 })
  const [value, setValue] = useState("")
  const [jetClubPlan, setJetClubPlan] = useState([])
  const getJetClubPlan = async () => {
    const { data } = await requests.getJetClubPlanList()
    if (data.succeed) {
      setValue(data.value[0].name)
      setJetClubPlan(data.value)
    }
  }

  useEffect(() => {
    getJetClubPlan()
  }, [])
  const handleChange = (e, newValue) => {
    setValue(newValue)
  }
  return (
    <Box
      sx={{
        bgcolor: "white",
        borderRadius: "10px",
        p: isMobile ? "2px" : "10px"
      }}
    >
      <Tabs
        value={value}
        onChange={handleChange}
        variant='scrollable'
        scrollButtons='auto'
        allowScrollButtonsMobile
        aria-label='scrollable auto tabs example'
      >
        {jetClubPlan?.map(plan => {
          return <Tab key={plan.name} value={plan.name} label={plan.name} />
        })}
      </Tabs>

      <Box
        sx={{
          width: isMobile ? "100%" : "85%",
          marginX: "auto",
          mt: 2,
          borderRadius: "8px",
          backgroundColor: "#fdfdfd"
        }}
      >
        <Plan
          name={value}
          amount={jetClubPlan?.find(plan => plan.name === value)?.amount}
          variants={jetClubPlan?.find(plan => plan.name === value)?.variants}
          useInSmallSize={false}
        />
      </Box>
    </Box>
  )
}
